export default "__VITE_ASSET__BX6RnJB1__"